import { t } from "@/i18n-js/instance";
import type { Room } from "@circle-react/types/Live/Room";
import { Toolbar } from "../../Toolbar";
import { useLiveUI } from "../../store";
import { useCanOpenRoomInfo } from "./useCanOpenRoomInfo";

interface InfoButtonProps {
  isHost?: boolean;
  room: Room;
}

export const InfoButton = ({ room, isHost = false }: InfoButtonProps) => {
  const { toggleIsRoomInfoOpen } = useLiveUI();
  const { canOpenRoomInfo, roomType } = useCanOpenRoomInfo(room, isHost);

  if (!canOpenRoomInfo) {
    return null;
  }

  return (
    <Toolbar.IconButton
      icon="16-info"
      tooltipText={t(`live_streams.room.button_tooltips.${roomType}.info`)}
      onClick={toggleIsRoomInfoOpen}
    />
  );
};
